module.exports = __webpack_public_path__ + "static/Gotham-Medium-c51e7ee3660ca7798789731493a8e33f.woff2";